export default "__VITE_ASSET__cbb1ceee__"